import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import api from "../http";
import {useStore} from "../contexts/AppContext";
import CustomLoader from "./ux_ui/CustomLoader";
import './styles/History.css'
import ActivityTimeline from "./ux_ui/ActivityTimeline";




const DocumentHistory = () => {
    const {history, setHistory, row} = useStore()
    const [historyLoading, setHistoryLoading] = useState(true)
    const {documentId} = useParams();



    useEffect(() => {
        const abortController = new AbortController();
        setHistoryLoading(true)
        
        const fetchData = async () => {
            try {
                const id = documentId || row?.id;
                if (!id) return;

                const response = await api.get(`supabase/document-history/${id}`, {
                    signal: abortController.signal
                });
                if (response.status === 200 && response.data && !abortController.signal.aborted) {
                    setHistory(response.data);
                }
            } catch (e) {
                // Ignore abort errors
                if (e.name !== 'AbortError' && e.name !== 'CanceledError') {
                    console.log(e)
                }
            } finally {
                if (!abortController.signal.aborted) {
                    setHistoryLoading(false)
                }
            }
        };

        fetchData();
        
        return () => {
            abortController.abort();
        };
        // eslint-disable-next-line
    }, [documentId, row?.id]);

    if (historyLoading) return <CustomLoader/>


    return (
        <ActivityTimeline history={history}/>
    );
};

export default DocumentHistory;
